import { render, staticRenderFns } from "./TarimasComponent.vue?vue&type=template&id=a0db638e&"
import script from "./TarimasComponent.vue?vue&type=script&lang=js&"
export * from "./TarimasComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports